import React from "react";
import * as Toast from "@radix-ui/react-toast";
import { StarFill } from "react-bootstrap-icons";
import styled, { keyframes } from "styled-components";

interface RatingToastProps {
    show: boolean;
    onClose: () => void;
}

const slideIn = keyframes`
    from { transform: translateX(calc(100% + 16px)); }
    to   { transform: translateX(0); }
`;

const fadeOut = keyframes`
    from { opacity: 1; }
    to   { opacity: 0; }
`;

const ToastViewport = styled(Toast.Viewport)`
    position: fixed;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    display: flex;
    flex-direction: column;
    gap: 8px;
    width: 390px;
    max-width: 100vw;
    margin: 0;
    padding: 8px;
    list-style: none;
    z-index: 999999999;
    outline: none;
`;

const ToastRoot = styled(Toast.Root)`
    border: 1px solid rgba(184, 249, 79, 0.32);
    border-radius: 6px;
    overflow: hidden;
    background: transparent;

    &[data-state="open"] {
        animation: ${slideIn} 150ms cubic-bezier(0.16, 1, 0.3, 1);
    }
    &[data-state="closed"] {
        animation: ${fadeOut} 100ms ease-in;
    }
`;

const ToastHeader = styled.div`
    display: flex;
    align-items: center;
    gap: 8px;
    padding: 8px 12px;
    background: rgba(11, 11, 11, 1);
    font-size: 12px;
    color: #fff;
`;

const ToastTitle = styled(Toast.Title)`
    font-weight: 700;
    color: #fff;
    font-size: 12px;
    flex: 1;
`;

const ToastCloseButton = styled(Toast.Close)`
    background: transparent;
    border: none;
    color: #fff;
    cursor: pointer;
    font-size: 16px;
    line-height: 1;
    opacity: 0.7;
    padding: 0;

    &:hover {
        opacity: 1;
    }
`;

const ToastBody = styled(Toast.Description)`
    padding: 8px 12px;
    background: rgba(11, 11, 11, 1);
    color: #fff;
    font-size: 12px;
    border-radius: 0 0 6px 6px;
`;


const RatingToast: React.FC<RatingToastProps> = ({ show, onClose }) => {
    return (
        <Toast.Provider swipeDirection="right" duration={5000}>
            <ToastRoot
                open={show}
                onOpenChange={(open: boolean) => !open && onClose()}
                data-cemboo="rating-toast"
            >
                <ToastHeader data-cemboo="rating-toast-header">
                    <StarFill style={{ color: "rgb(255, 255, 255)" }} />
                    <ToastTitle data-cemboo="rating-toast-title">Thank you!</ToastTitle>
                    <ToastCloseButton data-cemboo="rating-toast-close" aria-label="Close">
                        ×
                    </ToastCloseButton>
                </ToastHeader>
                <ToastBody data-cemboo="rating-toast-body">
                    Your rating has been successfully saved.
                </ToastBody>
            </ToastRoot>
            <ToastViewport data-cemboo="rating-toast-viewport" />
        </Toast.Provider>
    );
};

export default RatingToast;
